module.exports = __webpack_public_path__ + "static/img/solution2.1d6ebd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/solution2.png
// module id = XX2A
// module chunks = 1